module.exports = __webpack_public_path__ + "img/ben-pro.3cf6a2de.jpg";